var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResearchRecommendation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1468",
    "data-name": "Group 1468",
    transform: "translate(-22.252 -147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4098",
    "data-name": "Path 4098",
    d: "M10,0A10,10,0,1,1,0,10,10,10,0,0,1,10,0Z",
    transform: "translate(22.252 147)",
    fill: "#66a2df"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Kompozycja_19",
    "data-name": "Kompozycja 19",
    transform: "translate(30.978 155.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1493",
    "data-name": "Group 1493",
    transform: "translate(-5.767 -4.786)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5791",
    "data-name": "Path 5791",
    d: "M13.11,11.94,9.824,8.653A5.445,5.445,0,1,0,8.6,9.86L11.9,13.154ZM1.337,5.438a4.1,4.1,0,1,1,4.1,4.1A4.1,4.1,0,0,1,1.337,5.438Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1492",
    "data-name": "Group 1492",
    transform: "translate(2.226 4.262)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5792",
    "data-name": "Path 5792",
    d: "M26.5,50.75V53.6a3.671,3.671,0,0,0,1.694,1.509V50.75Z",
    transform: "translate(-26.5 -50.75)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5793",
    "data-name": "Path 5793",
    d: "M51.949,63.75v3.434a3.793,3.793,0,0,0,1.694.106V63.75Z",
    transform: "translate(-49.812 -62.658)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5794",
    "data-name": "Path 5794",
    d: "M80.021,71.553v-1.8H78.327v2.913A3.7,3.7,0,0,0,80.021,71.553Z",
    transform: "translate(-73.974 -68.154)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearchRecommendation);
export default __webpack_public_path__ + "static/media/research-recommendation.f89c899e38d8d31f0ef8b73a2844dd99.svg";
export { ForwardRef as ReactComponent };